import { useSnackbar } from 'react-simple-snackbar';
import CustomSnackbar from '../../components/CustomSnackbar/CustomSnackbar';
import { SNACKBAR_VARIANTS } from '../../constants/snackbarVariants';

export function useAppSnackbars() {
    const [openSuccess] = useSnackbar(SNACKBAR_VARIANTS.success.options);
    const [openError] = useSnackbar(SNACKBAR_VARIANTS.error.options);
    const [openInfo] = useSnackbar(SNACKBAR_VARIANTS.info.options);

    return {
        openSuccess: (message) =>
            openSuccess(<CustomSnackbar message={message} variant="success" />),

        openError: (message) =>
            openError(<CustomSnackbar message={message} variant="error" />),

        openInfo: (message) =>
            openInfo(<CustomSnackbar message={message} variant="info" />),
    };
}
